import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-empty-cart",
  templateUrl: "./empty-cart.component.html",
  styleUrls: ["./../cart.component.css"]
})
export class EmptyCartComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}



// WEBPACK FOOTER //
// ./src/app/functional_components/cart/empty-cart/empty-cart.component.ts